/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import { Loading } from '../components/Loadings/loading';
import { TableUnitBranchs } from './components/TableUnitBranchs';
//import { MyPortal } from './components/my-portal'

const unitBranchsBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const UnitBranchsPage: FC = () => {
  return (
    <div className='column g-5 g-xl-8 pt-2'>
        <TableUnitBranchs className='card-xl-stretch mb-xl-8'/>
    </div>
  )
}

const UnitBranchsWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={unitBranchsBreadcrumbs}>Gerenciamento de Unidades (Filiais)</PageTitle>
      <UnitBranchsPage />
    </>
  )
}

export {UnitBranchsWrapper}
